const urls = {
  LOCAL: {
    strapi: 'http://localhost:1337',
    s3Bucket: 'https://statics.bitexen.com'
  },
  TEST: {
    strapi: 'https://test.bitexen.com/cms-api',
    s3Bucket: 'https://statics.bitexen.com'
  },
  PROD: {
    strapi: 'https://bulten.bitexen.com/api',
    s3Bucket: 'https://statics.bitexen.com'
  }
};

export const endpoints = {
  strapi: urls[process.env.REACT_APP_ENV_NAME].strapi,
  s3Bucket: urls[process.env.REACT_APP_ENV_NAME].s3Bucket
};
